/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function Subdirectory({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 17 16" {...props}><path fill="currentColor" d="M2.872 1.465a.6.6 0 0 0-1.2 0zm-.6 10.008h-.6zm-.6-10.008v10.008h1.2V1.465zm1.6 11.608h4.206v-1.2H3.272zm-1.6-1.6a1.6 1.6 0 0 0 1.6 1.6v-1.2a.4.4 0 0 1-.4-.4z" /><path fill="currentColor" d="M2.872 3.814a.6.6 0 1 0-1.2 0zm-.6.655h.6zm-.6-.655v.655h1.2v-.655zm1.6 2.255h4.206v-1.2H3.272zm-1.6-1.6a1.6 1.6 0 0 0 1.6 1.6v-1.2a.4.4 0 0 1-.4-.4z" /><rect width={6.75} height={3.75} x={7.478} y={3.594} stroke="currentColor" strokeLinejoin="round" strokeWidth={1.2} rx={0.5} /><rect width={6.75} height={3.75} x={7.478} y={10.785} stroke="currentColor" strokeLinejoin="round" strokeWidth={1.2} rx={0.5} /></svg>;
}
;